import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { MsalCallbackComponent } from './components/msal-callback/msal-callback.component';
import { FrontChannelLogoutComponent } from './components/frontchannel-logout/frontchannel-logout.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'chat',
    // La ruta existe porque el login navega aquí, pero no monta ningún componente:
    // la aplicación no usa router-outlet, el shell es AppComponent.
    children: []  
    
  },
  
  {
    path: 'auth/callback',
    component: MsalCallbackComponent
  },
  {
    path: 'frontchannel-logout',
    component: FrontChannelLogoutComponent
  },
  {
    // m31.ionet.mx/{clave}: entrada personalizada de un cliente. Como 'chat', no monta ningún
    // componente: LoginBrandingService lee la clave de la URL y el login pinta la personalización.
    // Va después de las rutas propias para que 'login', 'chat', etc. nunca se tomen por una clave.
    path: ':clave',
    children: []
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];